import { render } from "./EditTubeAndTypesComponent.vue?vue&type=template&id=33334594&scoped=true"
import script from "./EditTubeAndTypesComponent.vue?vue&type=script&lang=js"
export * from "./EditTubeAndTypesComponent.vue?vue&type=script&lang=js"

import "./EditTubeAndTypesComponent.vue?vue&type=style&index=0&id=33334594&scoped=true&lang=css"

import exportComponent from "D:\\Cotizador Frontend\\dyc_cotizador_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33334594"]])

export default __exports__